(function () {
	'use strict';
	// if client.js return data from installed AV

	function checkClient() {
		if (typeof avastGlobals.client !== 'undefined') {
			window.location.href = 'lp-safe-emailing-win-browser?brcmpgid=6306';
		}
	}

	window.addEventListener('clientLoaded', function () {
		checkClient();
	})

	checkClient();
})(),

(function () {
	'use strict';
	// if client.js return data from installed AV
	var $ = avm.require('jquery'),
    
		url_DEFAULT = 'https://avast.sng.link/Dp3jo/4129/jvio',
		avastGlobals = typeof window.avastGlobals !== 'undefined' ? window.avastGlobals : {};

        var detected = avastGlobals.detect;

	if ((typeof avastGlobals.web !== 'undefined') && (detected.os.isAndroid || detected.os.isIOS)) {
			window.location.href = url_DEFAULT;
	} else {
		window.dataLayer.push({
			'event': 'notRedirected'
		});
	}

})();
